// ** UseJWT import to get config
import useJwt from "@/utils/jwt/useJwt";
import { calculateUnseenMessageCount, clearRoomInitialized, clearRooms, clearUnreadMessageCount, selectRoom } from "@/store/reducers/room";
import { closeAllMessages, setSendMsg } from "@/store/reducers/messages";
import { clearUser } from "@/store/reducers/user";
import { setSocketConnection } from "./user";
import { clearSession, setSession, setUserData } from "@/store/reducers/auth";
import {
  ACCESS_TOKEN_TTL_MS,
  REFRESHED_TOKEN_TTL_MS,
  clearAuthSession,
  normalizeAuthSession,
  persistAuthSession,
} from "@/utils/authSession";

// ** Handle User Login
export const handleLogin = (data) => {
  return (dispatch) => {
    const session = normalizeAuthSession(data, {}, ACCESS_TOKEN_TTL_MS);

    // ** Add to user, accessToken & refreshToken to localStorage
    dispatch(setSocketConnection(false))
    dispatch(calculateUnseenMessageCount())
    dispatch(setSession(session));

    persistAuthSession(session);
  };
};

// ** Handle User Logout
export const handleLogout = () => {
  return (dispatch) => {
    // ** Remove user, accessToken & refreshToken from localStorage
    dispatch(selectRoom({}));
    dispatch(clearRoomInitialized());
    dispatch(clearUnreadMessageCount());
    dispatch(closeAllMessages());
    dispatch(clearRooms());
    dispatch(clearUser());
    dispatch(setSendMsg(""));

    dispatch(clearSession());

    clearAuthSession();
  };
};

export const relogin = () => async (dispatch, getState) => {

  try {
    const res = await useJwt.refreshToken();

    if (res.data.ResponseCode !== 0) {
      dispatch(handleLogout());
      return null;
    }

    const session = normalizeAuthSession(
      res.data.ResponseResult,
      getState().auth,
      REFRESHED_TOKEN_TTL_MS
    );

    dispatch(setSession(session));
    persistAuthSession(session);

    return session;

  } catch (err) {
    console.error("Re-login failed", err);
    dispatch(handleLogout());
    return null;

  }
};

export const updateUserData = (data) => (dispatch) => {
  dispatch(setUserData(data));
  localStorage.setItem("userData", JSON.stringify(data));
};
